import { projects } from "./projects-data.js";

<theme-body-top/>
<${$global.contentComponent || {}}>
  <div>No content</div>
</${$global.contentComponent || {}}>

<div class="home-grid">
  <!-- Left Column -->
  <div class="home-grid-main">
    <!-- Projects Section -->
    <div class="home-section">
      <div class="home-section-header">
        <div>
          <h3>Open Source Projects</h3>
          <p class="home-section-desc">Tools and libraries I maintain</p>
        </div>
        <a href="/projects" class="home-section-link">View All <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></a>
      </div>
      <div class="home-projects-grid">
        <for|project| of=projects>
          <a href=project.href target="_blank" rel="noreferrer" class="home-project-card group">
            <div class="home-project-card-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
            </div>
            <h4>${project.title}</h4>
            <p>${project.description}</p>
          </a>
        </for>
      </div>
    </div>
    <!-- Blog Section -->
    <if=$global.registry?.root?.length>
      <section class="home-section">
        <div class="home-section-header">
          <div>
            <h3>Latest Posts</h3>
            <p class="home-section-desc">Technical thoughts and notes</p>
          </div>
          <a href="/blogs" class="home-section-link">View All <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></a>
        </div>
        <div class="post-list">
          <for|post| of=$global.registry.root
            .filter(post => post.metadata.date)
            .sort((a, b) => new Date(b.metadata.date) - new Date(a.metadata.date))
            .slice(0, 3)>
            <a class="post-item" href=post.urlPath>
              <span class="post-date">
                ${post.metadata.date.split('T')[0].split('-').join(' / ')}
              </span>
              <div class="post-item-content">
                <h2>${post.metadata.title}</h2>
                <if=post.metadata.description>
                  <p>${post.metadata.description}</p>
                </if>
                <div class="post-item-footer">
                  <div class="post-tags">
                    <for|tag| of=post.metadata.tags || []>
                      <span class="post-tag">#${tag}</span>
                    </for>
                  </div>
                  <span class="read-entry">Read Entry <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></span>
                </div>
              </div>
            </a>
          </for>
        </div>
      </section>
    </if>
  </div>
</div>
